/**
 * Use Case: Logout
 * Business logic for user logout
 */

import * as Sentry from "@sentry/react";
import type { IAuthRepository } from "../repository/IAuthRepository";
import { container, TYPES } from "../../di/AuthModule";

export const LogoutUseCase = (): void => {
  const repository = container.get<IAuthRepository>(TYPES.IAuthRepository);
  repository.clearToken();
  Sentry.setUser(null);
};

